<div class="ui-g ui-fluid clear-ui">
    <div class="ui-g-12">
        <h1 class="card__title--h1 color--white layout-page-title">Allocation Definitions</h1>
    </div>
    <div class="ui-g-12">

                    <div class="ui-helper-clearfix p-text-left" style="padding-bottom: inherit;">
                        <button icon="ui-icon-add" label="New" pButton (click)="createDefinition()"></button>
                    </div>
                
        <div #definitionGridContainer class="grid-loading-wrapper">
         <ejs-grid #gridSync id="definitionGrid"
          [dataSource]="definitions"
          [allowPaging]="true"
          [pageSettings]="{ pageSize: 200 }"
          [allowSorting]="true"
          [height]="gridHeight"
          [allowResizing]="true"
          [allowSorting]="true"
          [allowSelection]="true"
          [selectionSettings]="selectionOptions"
          [allowFiltering]="true"
          [filterSettings]="filterOptions" 
          [allowGrouping]='true'
          (actionComplete)="onActionComplete($event)"
          (dataBound)="onGridDataBound()"
          (rowSelected)="onGridRowSelected($event)"
          (recordDoubleClick)="onGridRowDoubleClick($event)">
    <e-columns>
    <e-column *ngFor="let col of colsSync"
              [field]="col.field"
              [headerText]="col.header"
              [width]="col.width || 150"
              [textAlign]="'Left'">
    </e-column>
    <e-column headerText="Actions" [textAlign]="'Center'" [width]="150" [customAttributes]="actionColumnAttributes">
        <ng-template #template let-data>
            <div class="actions-cell">
                <div class="action-menu-wrapper" (click)="$event.stopPropagation()">
                    <button
                        type="button"
                        class="action-menu-toggle"
                        title="Actions"
                        (click)="toggleDropdown(data, $event)"
                    >
                        &#8942;
                    </button>
                    <ul class="action-menu" *ngIf="isActionMenuOpen(data)">
                        <li (click)="onActionMenuClick('edit', data, $event)">
                            <i class="pi pi-pencil"></i>
                            <span>Edit</span>
                        </li>
                        <li class="action-menu-danger" (click)="onActionMenuClick('delete', data, $event)">
                            <i class="pi pi-trash"></i>
                            <span>Delete</span>
                        </li>
                    </ul>
                </div>
            </div>
</ng-template>
  <!--    <ng-template #template let-data>
        <button class="ui-button-information ui-button__center" pButton
                                (click)="viewDefinition(data)" [disabled]="isDisabled" pTooltip="Edit" tooltipPosition="top"
                                icon="ui-icon-edit"></button>
        <button class="ui-button-information ui-button__center" pButton
                                (click)="deleteDefinition(data)" [disabled]="isDisabled" pTooltip="Delete" tooltipPosition="top"
                                icon="ui-icon-delete"></button>
      </ng-template>-->
    </e-column>
  </e-columns>
        </ejs-grid>
            <div *ngIf="loadingDefinitions" class="grid-loading-overlay">
                <p-progressSpinner></p-progressSpinner>
            </div>
        </div>

        <!--<div class="card p-p-0">
         
            <p-table #tableDefinitions [columns]="cols" [value]="definitions" dataKey="id" [paginator]="true" [rows]="20" [scrollable]="true"
                paginatorPosition="bottom"  styleClass="p-datatable-striped">
                <ng-template pTemplate="caption">
                    <div class="ui-helper-clearfix p-text-left">
                        <button icon="ui-icon-add" label="New" pButton (click)="createDefinition()"></button>
                    </div>
                </ng-template>
                <ng-template pTemplate="header" let-columns>
                    <tr>
                        <th *ngFor="let col of columns" [pSortableColumn]="col.field">
                            {{col.header}}
                            <p-sortIcon [field]="col.field"></p-sortIcon>
                        </th>
                        <th class="p-text-right">
                            Actions
                        </th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-rowData let-columns="columns">
                    <tr [pSelectableRow]="rowData" [pContextMenuRow]="rowData" (dblclick)="viewDefinition(rowData)">

                        <td *ngFor="let col of columns">
                            {{rowData[col.field]}}
                        </td>
                        <td class="p-text-right">
                            <button class="ui-button-information ui-button__center" pButton
                                (click)="viewDefinition(rowData)" [disabled]="isDisabled" pTooltip="Edit" tooltipPosition="top"
                                icon="ui-icon-edit"></button>
                            <button class="ui-button-information ui-button__center" pButton
                                (click)="deleteDefinition(rowData)" [disabled]="isDisabled" pTooltip="Delete" tooltipPosition="top"
                                icon="ui-icon-delete"></button>
                        </td>
                    </tr>
                </ng-template>
            </p-table>
        </div>-->
    </div>
</div>
